### INIT NG-APP ###
do ->
  'use strict'

  angular.module 'mainApp', []

  # END BLOCK SCRIPT
  return
